import { BrowserRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthProvider } from "@/contexts/AuthContext";
import { AppRoutes } from "@/routes";
import { ErrorBoundary } from "@/components/shared/ErrorBoundary";
import { AuthenticatedLocalGatewayHandoffProvider } from "@/features/storages/LocalGatewayHandoffContext";

export function App() {
  const { t } = useTranslation();

  return (
    <ErrorBoundary
      errorTitle={t("errorBoundary.title")}
      retryLabel={t("actions.retry")}
    >
      <BrowserRouter>
        <AuthProvider>
          <AuthenticatedLocalGatewayHandoffProvider>
            <AppRoutes />
          </AuthenticatedLocalGatewayHandoffProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
